import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeStore {
  /** Текущая тема */
  theme: Theme;

  /** Установить тему */
  setTheme: (theme: Theme) => void;

  /** Переключить тему */
  toggleTheme: () => void;

  /** Тёмная тема активна */
  isDark: () => boolean;
}

/** Применяет класс dark к <html> */
function applyThemeToDOM(theme: Theme): void {
  if (theme === 'dark') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}

/**
 * Глобальный стор для управления темой приложения
 * Сохраняет выбор в localStorage, применяет класс dark к <html>
 */
export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'light',

      setTheme: (theme: Theme) => {
        applyThemeToDOM(theme);
        set({ theme });
      },

      toggleTheme: () => {
        const next = get().theme === 'light' ? 'dark' : 'light';
        applyThemeToDOM(next);
        set({ theme: next });
      },

      isDark: () => get().theme === 'dark',
    }),
    {
      name: 'toive-theme',
      // version — если структура стейта поменяется в будущем, бампаем эту цифру
      // и добавляем migrate: (persistedState, oldVersion) => ... чтобы не падать
      // у юзеров со старым localStorage. Без version любая правка TypeScript-типа
      // ломает рестор с runtime ошибкой.
      version: 1,
      onRehydrateStorage: () => (state) => {
        // При восстановлении из localStorage — применяем тему к DOM
        if (state) {
          applyThemeToDOM(state.theme);
        }
      },
    },
  ),
);